<template>
    <div>
        <!--   direct
        {{fid}}
        {{crsList}}
        {{crs_off_id}}
        {{feedback_list}}
       Feedback Questions : {{feedback_questions_and_option_list}} -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Give Subject Feedback
                    </strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <!-- <v-btn fab small color="white" outlined icon @click="close()"><v-icon> mdi-close </v-icon></v-btn> -->
            </v-toolbar>
            <span v-if="feedback_list != null">
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3"> <strong>Academic Year : </strong>{{feedback_list[0].academic_year}} </v-col>
                    <v-col cols="12" sm="3" md="3"> <strong>Feedback Type : </strong>{{feedback_list[0].feedbacktype}} </v-col>
                    <v-col cols="12" sm="3" md="3"> <strong>Feedback Number : </strong>{{feedback_list[0].feedback_number}} </v-col>
                </v-row>
                <v-row justify="center" dense v-if="crs_list != null">
                    <v-col cols="12" sm="3" md="3"> <strong>Subject Code : </strong>{{crs_list[crs_index].crs_code}} </v-col>
                    <v-col cols="12" sm="3" md="3"> <strong>Subject Name : </strong>{{crs_list[crs_index].crs_name}} </v-col>
                    <v-col cols="12" sm="3" md="3"> <strong>Teacher : </strong>{{crs_list[crs_index].crs_inst}} </v-col>
                </v-row>
                <v-card class="box" v-for="(item,index) in feedback_questions_and_option_list" :key="index">
                    <v-row dense>
                        <v-col cols="12" sm="10" md="10">
                            <strong>Q. No.</strong>{{item.qno}}
                            <span v-html="item.question_statement"></span>
                            <!-- <strong>{{item.question_statement}}</strong> -->
                        </v-col>
                        <!-- <v-col cols="12" sm="2" md="2"><strong>Marks :</strong>{{item.weightage}}</v-col> -->
                        <v-col cols="12" sm="12">
                            <span class="crs"> <strong> Options </strong></span>
                            <span v-for="(opt,opt_index) in item.option_list" :key="opt_index">
                                <v-row dense class="pl-2">
                                    <input class="radiospace" type="radio" v-if="item.selected_option != null" :name="item.id" :checked="item.selected_option == opt.opt_id" />
                                    <input type="radio" class="radiospace" v-else  v-model="item.selected_option"  v-bind:value="opt.opt_id"/>
                                    <span class="p-0 span-mr" v-html="opt.option_statement"> </span>
                                </v-row>
                            </span>
                        </v-col>
                    </v-row>
                </v-card>
                <v-textarea dense color="#0f2027" v-model="crs_list[crs_index].comment" hint="Comment(If Any)" persistent-hint prepend-icon="mdi-comment" outlined lable="Comment(If Any)"
                 ></v-textarea>
            </span>
            <v-row justify="center">
                <v-btn class="button" v-if="crs_list.length-1 != crs_index" @click="saveFeedback(feedback_questions_and_option_list)" :loading="loader">Save and Next</v-btn>
                 <v-btn class="button" v-if="crs_list.length -1 == crs_index" @click="submitFeedback(feedback_questions_and_option_list)" :loading="loader">Submit All Subject Feedback</v-btn>
            </v-row>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                overlay: false,
                learner_outstanding_data: null,
                fid: null,
                crsList: null,
                feedback_list: null,
                ay: null,
                feedback_questions_and_option_list: null,
                crs_index: 0,
                crs_list: null,
                opt_id:null,
                opt_list:[],
                question_list:[],
                selected:"",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                loader:false,
            };
        },

        created() {
            this.fid = JSON.parse(this.$session.get("fid"));
            this.crs_list = JSON.parse(this.$session.get("crsList"));
            this.feedback_list = JSON.parse(this.$session.get("feedback_list"));
        },
        mounted() {
            this.onload();
        },
        methods: {
            submitFeedback(feedback_questions_and_option_list){
                 for(var i = 0;i < this.feedback_questions_and_option_list.length;i++)
                {
                    if(this.feedback_questions_and_option_list[i].selected_option == null){
                        this.showSnackbar("#b71c1c", "Please give all questions answer..."); // show snackbar
                        return 
                    }
                }
                 const data = {
                    fid: this.fid,
                    crs_off_id: this.crs_list[this.crs_index].crs_offering,
                    crs_off_learner: this.crs_list[this.crs_index].courseOfferingLearner,
                    crs_off_inst: this.crs_list[this.crs_index].crs_inst_id,
                    comment: this.crs_list[this.crs_index].comment,
                    feedback_questions_and_option_list:feedback_questions_and_option_list
                }
                this.loader=true
                 axios
                .post("/Feedback/submitFeedback", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", res.data.status_reason);
                        this.loader=false
                         this.$router.push({
                            name: "give-subject-feedback",
                        });
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                     this.loader=false
                })
                .finally(() => {
                     this.loader=false
                });
            },
              saveFeedback(feedback_questions_and_option_list){
                for(var i = 0;i < this.feedback_questions_and_option_list.length;i++)
                {
                    if(this.feedback_questions_and_option_list[i].selected_option == null){
                        this.showSnackbar("#b71c1c", "Please give all questions answer..."); // show snackbar
                        return 
                    }
                }
                // alert(this.crs_list[this.crs_index].comment)
                // alert(this.crs_list[this.crs_index].crs_inst_id)
                this.loader=true
                const data = {
                    fid: this.fid,
                    crs_off_id: this.crs_list[this.crs_index].crs_offering,
                    crs_off_learner: this.crs_list[this.crs_index].courseOfferingLearner,
                    crs_off_inst: this.crs_list[this.crs_index].crs_inst_id,
                    comment: this.crs_list[this.crs_index].comment,
                    feedback_questions_and_option_list:feedback_questions_and_option_list
                }
                this.crs_index = this.crs_index + 1
                axios
                .post("/Feedback/saveSubjectFeedback", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", res.data.status_reason);
                        this.loader=false
                        this.onload()
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                     this.loader=false
                })
                .finally(() => {
                     this.loader=false
                });
            },
             showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                //alert(this.crs_index)
                let list
                //if(this.crs_index == 0){
                   // alert("in if")
                    for(var i = 0;i < this.crs_list.length;i++){
                        if(i == this.crs_index){
                          //  alert("in if 2")
                            list = this.crs_list[i]
                        }
                    }
               // }
                // else {
                //     list = ""
                // }
                const data = {
                    fid: this.fid,
                    list:list
                };
                axios
                    .post("/Feedback/getCourseFeedBackQuestions", data)
                    .then((res) => {
                        this.feedback_questions_and_option_list = res.data.feedback_questions_and_option_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
    };
</script>
<style scoped>
    .span-mr {
        margin: 0rem !important;
        padding-top: none !important;
    }
    .radiospace {
        margin: 0.2rem !important;
        padding-top: 0.5rem !important;
    }
</style>
